<template>
    <div>
        <v-autocomplete
            v-model="agency"
            :items="agencies"
            item-value="id"
            item-text="name"
            outlined
            dense
            :color="inputColor"
            :background-color="backgroundColor"
            :readonly="readonly"
            :loading="loading"
            :clearable="!readonly"
            @input="input"
            :rules="rules"
            hide-details="auto"
        ></v-autocomplete>

        <input type="hidden">
    </div>
</template>

<script>
import {ref, watch} from "vue";
import useSharedData from "@/use/SharedData.js";
import axios from "axios";

export default {
    name: "StrBankAgencyAutocomplete",
    props: {
        value: [Number, Array],
        readonly: Boolean,
        label: String,
        rules: Array,
        bankId: Number,
    },
    setup(props, {emit}) {
        const {loading, inputColor, backgroundColor} = useSharedData();

        const agency = ref(null);
        const agencies = ref([]);

        function findAll() {
            loading.value  = true;
            axios.get(`/banks/${props.bankId}/agencies`).then(response => {
                agencies.value = response.data;
            }).finally(() => {
                loading.value = false;
            });
        }

        function input(value) {
            emit('input', value)
        }

        watch(() => props.value, () => {
            agency.value = props.value;
        }, {immediate: true});

        watch(() => props.bankId, () => {
           if(props.bankId) {
               findAll();
           }
        }, {immediate: true});

        return {
            loading,
            inputColor,
            backgroundColor,
            agency,
            agencies,
            input,
        }
    }
}
</script>

<style scoped>

</style>